import { type PaymentAccountCard } from "@/features/payments/types/payment-account-cards";

import { useCardDisclaimer } from "../../../hooks/use-card-disclaimer";

/** Issuer disclosure for the card on screen, or nothing when it has none to show. */
export const CardDisclaimer = ({ card }: { card: PaymentAccountCard }) => {
  const disclaimer = useCardDisclaimer(card);

  if (!disclaimer) {
    return null;
  }

  return (
    <div className="flex w-full justify-center">
      <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 max-w-4xl">
        <p
          id="disclaimer_text"
          className="text-[11px] text-gray-500 leading-relaxed"
        >
          {disclaimer}
        </p>
      </div>
    </div>
  );
};
